import { useTranslation } from "react-i18next";
import { SectionCard } from "../../components/SectionCard/SectionCard.js";
import { SectionCardVStack } from "../../components/SectionCard/SectionCardVStack.js";
import { NavigationActionButton } from "../../components/NavigationActionButton/NavigationActionButton.js";

export function WildlifeSection() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-24">
            <SectionCard
                id="wildlife"
                className="bg-gray !gap-12"
                img="cards/wildlife-cropped.png"
                gradientClassName="gray-gradient"
            >
                <SectionCardVStack
                    title={t("home-wildlife-card-title")}
                    text={t("home-wildlife-card-text")}
                    className="mr-0 sm:mr-32 lg:mr-[36rem]"
                >
                    <NavigationActionButton
                        className="my-0 !text-black !bg-white hover:!bg-[rgba(255,255,255,0.9)] w-full sm:w-min"
                        label={t("learn-more")}
                        href="/wildlife"
                    />
                </SectionCardVStack>
            </SectionCard>
        </div>
    );
}
